import template from "./timezone-selector.html";

const TimezoneSelectorComponent = {
  bindings: {
    defaultValue: "<",
    onChange: "&",
  },
  template: template,
  controller: class TimezoneController {
    /* @ngInject */
    constructor($scope, moment) {
      this.$scope = $scope;
      this.moment = moment;
    }

    $onInit() {
      this.timezones = this.moment.tz
        .names()
        .map((timezone) => this.calculateTimezoneUtc(timezone));
      this.setTimezone();

      this.$scope.$watch(
        () => this.timezone,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal))
            this.onChange({
              oldTimezone: oldVal,
              newTimezone: this.timezone.name,
            });
        }
      );
    }

    setTimezone() {
      this.timezone = this.calculateTimezoneUtc(this.defaultValue);
      this.onChange({
        oldTimezone: this.defaultValue,
        newTimezone: this.timezone.name,
      });
    }
    calculateTimezoneUtc(timezone) {
      const timezoneLocal = this.moment().tz(timezone).utcOffset();
      const centralOffset = this.moment().utc().utcOffset();
      const hoursDifference = (timezoneLocal - centralOffset) / 60;
      return { name: timezone, utc: hoursDifference };
    }
    getTimezoneLabel(timezone) {
      return `${timezone.name.replaceAll("_", " ")} (UTC${
        timezone.utc >= 0 ? `+${timezone.utc}` : timezone.utc
      })`;
    }
  },
};

export default TimezoneSelectorComponent;
